//help bubbles provide ui elements we can place to provide guidance for users
//pass it the message and coordinates and it will render a bubble at the coordinates

import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

// Animation keyframes
const floatAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
`;

// Styled help bubble component
const StyledHelpBubble = styled(Box)(({ theme }) => ({
  position: 'absolute',
  padding: '12px 16px',
  borderRadius: '12px',
  maxWidth: '300px',
  boxShadow: theme.shadows[2],
  animation: `${floatAnimation} 3s ease-in-out infinite`,
  backgroundColor: '#ffa726', // Orange 400 for both modes
  color: '#000000', // Black text for both modes
  border: `1px solid #fb8c00`, // Orange 600 border for both modes
  '&::before': {
    content: '""',
    position: 'absolute',
    bottom: '100%', // Position arrow at top of bubble
    left: '50%',
    transform: 'translateX(-50%)',
    borderWidth: '10px',
    borderStyle: 'solid',
    borderColor: `transparent transparent #ffa726 transparent`, // Match bubble color
  },
}));

export const HelpBubble = ({
  message,
  coordinates,
}: {
  message: string;
  coordinates: { x: number; y: number };
}) => {
  const theme = useTheme();

  return (
    <StyledHelpBubble
      sx={{
        left: `${coordinates.x}px`,
        top: `${coordinates.y}px`,
        zIndex: 9999,
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontWeight: 500, whiteSpace: 'pre-line' }}
      >
        {message}
      </Typography>
    </StyledHelpBubble>
  );
};
